import React from "react";
import { Formik, Form, Field } from "formik";
import TextInput from "./TextInput";
import Button from "./CustomButton";
import Icon from "@fortawesome/react-fontawesome";
import _ from "lodash";
import Loading from "./Loading";
import { Alert } from "reactstrap";
import * as Yup from "yup";

const initialValues = category => {
  const initial = {
    name: "",
    description: ""
  };
  return category ? _.pick(category, Object.keys(initial)) : initial;
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  description: Yup.string().required()
});

const CategoryForm = ({
  category,
  onSubmit,
  submittingCategory,
  failSubmitCategory
}) => {
  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues(category)}
      onSubmit={onSubmit}
      render={({ submitForm }) => {
        return (
          <Form>
            <Field
              name="name"
              label="Name"
              placeholder="Category Name"
              component={TextInput}
            />
            <Field
              name="description"
              label="Description"
              type="textarea"
              style={{ resize: "none" }}
              rows="3"
              placeholder="Category Description"
              component={TextInput}
            />
            <Button
              type="button"
              color="primary"
              fill
              disabled={submittingCategory}
              onClick={() => {
                submitForm();
              }}
            >
              {`${category ? "Update" : "Create"} Category`}{" "}
              <Icon icon="paper-plane" />
            </Button>
            {submittingCategory && <Loading label="Submitting" />}
            {failSubmitCategory && (
              <Alert color="danger">{failSubmitCategory}</Alert>
            )}
          </Form>
        );
      }}
    />
  );
};

export default CategoryForm;
